var _circle, _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgQuoteCircled(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 36,
    viewBox: "0 0 37 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18.3047,
    cy: 18,
    r: 18,
    fill: "black"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.7804 11C12.2473 11 10.7771 11.696 9.69304 12.935C8.60901 14.1739 8 15.8543 8 17.6065C8 19.3586 8.60901 21.039 9.69304 22.2779C10.7771 23.5169 12.2473 24.2129 13.7804 24.2129V11Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7812 11C14.931 11 16.0338 11.522 16.8468 12.4513C17.6598 13.3805 18.1165 14.6407 18.1165 15.9548C18.1165 17.2689 17.6598 18.5292 16.8468 19.4584C16.0338 20.3876 14.931 20.9097 13.7812 20.9097V11Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6632 11C23.1301 11 21.6599 11.696 20.5759 12.935C19.4918 14.1739 18.8828 15.8543 18.8828 17.6065C18.8828 19.3586 19.4918 21.039 20.5759 22.2779C21.6599 23.5169 23.1301 24.2129 24.6632 24.2129V11Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6641 11C25.8138 11 26.9165 11.522 27.7295 12.4513C28.5425 13.3805 28.9993 14.6407 28.9993 15.9548C28.9993 17.2689 28.5425 18.5292 27.7295 19.4584C26.9165 20.3876 25.8138 20.9097 24.6641 20.9097V11Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuoteCircled);
export default __webpack_public_path__ + "static/media/quote-circled.85841496a448293f9664257c63a5bdf8.svg";
export { ForwardRef as ReactComponent };